export const defaultAddressInformation = {
  country: "Canada",
  state: "Quebec",
  city: "Montréal",
  zipcode: "H2Z 1W7",
  address: "500 boulevard René-Lévesque Ouest 10ième étage",
};
